export default {
  title: "Gelieerde bedrijven",

  table: {
    noData: "Nog geen gekoppelde bedrijven",
  },

  input: {
    title: "Bedrijf toevoegen",
    company: "Bedrijf",
    type: "Type",
  },
}
